// extracted by mini-css-extract-plugin
module.exports = {"nav":"Pagination_nav__3wqaq","ul":"Pagination_ul__3zl-B","list":"Pagination_list__3AyS9","pagBtn":"Pagination_pagBtn__367NM"};